var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"title"},[_vm._v("Can’t add a new integration")]),_c('i',{staticClass:"mdi mdi-close-circle close-icon",on:{"click":function($event){return _vm.$bvModal.hide('noGroups')}}}),_c('p',{staticClass:"content"},[_vm._v(" No groups are available to be mapped for these credentials. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }